module.exports = __webpack_public_path__ + "img/ritualcropped.2abc9c10.jpg";